import { Box, MenuItem, Select } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '&.FDLastDropdown': {
    '& .FDSelectInput': {
      [theme.breakpoints.up('lg')]: {
        borderRight: 0,
      },
    },
  },
}));
export const StyledSelectInput = styled(Select)(({ theme }) => ({
  '&.FDSelectInput': {
    paddingLeft: 0,
    color: theme.palette.text.primary,
    fontSize: theme.spacing(2),
    borderRadius: 0,
    border: 0,
    borderRight: `1px solid ${theme.palette.divider[5]}`,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      border: `1px solid ${theme.palette.divider[5]}`,
      borderRadius: theme.spacing(0.5),
    },
    '& fieldset': {
      border: 0,
    },
    '& .MuiSelect-select': {
      padding: theme.spacing(2, 3, 2, 6),
      paddingRight: `${theme.spacing(3)} !important`,
      minHeight: 'unset',
      lineHeight: theme.spacing(2),
      '&.Mui-disabled': {
        background: 'unset',
      },
      '& .MuiTypography-root': {
        lineHeight: theme.spacing(2),
      },
    },
    '& svg': {
      flex: 'none',
      fontSize: theme.spacing(2.25),
      position: 'absolute',
      left: theme.spacing(3),
      cursor: 'pointer',
    },
    '&.Mui-disabled': {
      color: theme.palette.action.disabled,
    },

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '& .MuiInputAdornment-root': {
      pointerEvents: 'none',
    },
    '& .FDMenuItemText': {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}));
export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(0.5),
  transition: 'all 0.25s ease',
  '&.Mui-selected': {
    backgroundColor: theme.palette.action.hover,
    border: `1px solid ${alpha(theme.palette.common.white, 0.8)}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export default StyledBox;
